import React, {Fragment} from 'react';
import {Popup} from 'components';
import {useNamedSelector, toggle, includes} from 'helpers';
import {store} from 'store';

export function PopupShareStatus() {
  const { shareStatus } = useNamedSelector('settings.settings');
  return (
    <Fragment>
      <Popup.Menu.SubHeading>Share status</Popup.Menu.SubHeading>
      <Popup.Menu.Checkbox onClick={() => toggleStatus('mine')} checked={includes(shareStatus, 'mine')}>Mine</Popup.Menu.Checkbox>
      <Popup.Menu.Checkbox onClick={() => toggleStatus('byMe')} checked={includes(shareStatus, 'byMe')}>Shared By Me</Popup.Menu.Checkbox>
      <Popup.Menu.Checkbox onClick={() => toggleStatus('withMe')} checked={includes(shareStatus, 'withMe')}>Shared With Me</Popup.Menu.Checkbox>
    </Fragment>
  );
}

function toggleStatus(value) {
  store.dispatch({
    type: 'UI_SETTING',
    key: 'shareStatus',
    value: current => toggle(current, value, { separator: ', ', min: 1 }),
  });
}
